import { render } from "./index.vue?vue&type=template&id=24a6ab57&scoped=true"
const script = {}

import "./index.scss?vue&type=style&index=0&id=24a6ab57&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24a6ab57"]])

export default __exports__